import { Controller } from "@hotwired/stimulus";

// Fades + slides elements in as they scroll into view.
export default class extends Controller {
  static values = { delay: { type: Number, default: 0 } };

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.classList.add("is-visible");
      return;
    }

    this.element.classList.add("reveal");
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setTimeout(() => this.element.classList.add("is-visible"), this.delayValue);
        this.observer.disconnect();
      },
      { threshold: 0.15 },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }
}
